import { useEffect, useRef, useState } from 'react';
import OBR from '@owlbear-rodeo/sdk';
import { awardsForCharacter, type PlayerAward } from '../obr/achievementAwards.ts';
function titleCase(text: string) { return text.replaceAll('-', ' ').replace(/\b\w/g, x => x.toUpperCase()); }
export function AchievementNotice({ awards, characterId, onOpen }: { awards: PlayerAward[] | undefined; characterId: string; onOpen: () => void }) {
  const seen = useRef<Set<string> | null>(null);
  const [dismissed, setDismissed] = useState<string | null>(null);
  const relevant = awardsForCharacter(awards ?? [], characterId);
  useEffect(() => {
    if (awards === undefined) return;
    if (seen.current === null) { seen.current = new Set(awards.map(a => a.id)); return; }
    const received = relevant.filter(a => !seen.current!.has(a.id));
    for (const a of awards) seen.current.add(a.id);
    if (!received.length) return;
    const text = received.length === 1 ? `New Achievement! ${received[0]!.title}` : `${received.length} new achievements received!`;
    void OBR.notification.show(text, 'SUCCESS').catch(() => {});
  }, [awards, characterId]);
  const latest = relevant[0];
  if (!latest || dismissed === latest.id) return null;
  return <aside className="dcc-achievement-notice" aria-label="Latest achievement">
    <div><strong>Achievement received: {latest.title}</strong>{latest.description && <p>{latest.description}</p>}</div>
    <button type="button" onClick={onOpen}>View achievements</button><button type="button" className="dcc-creator-secondary" onClick={() => setDismissed(latest.id)} aria-label="Dismiss achievement notice">×</button>
  </aside>;
}
export function PlayAchievementsTab({ awards, characterId }: { awards: PlayerAward[] | undefined; characterId: string }) {
  const relevant = awardsForCharacter(awards ?? [], characterId);
  return <section className="dcc-play" aria-label="Achievements and rewards"><h2>Achievements</h2>
    <p className="dcc-creator-help">Recent achievements and their rewards. Rewards have already been added to your Inventory or the Party Inventory.</p>
    {!relevant.length && <p>No achievements have been received for this crawler yet.</p>}
    {relevant.map(a => <article className="dcc-creator-card" key={a.id}><h3>{a.title}</h3>
      {a.description && <p className="dcc-achievement-description">{a.description}</p>}
      <p className="dcc-creator-help">{a.party ? 'Party reward' : 'Personal reward'} · {new Date(a.at).toLocaleString()}{a.rarity || a.boxType ? ` · ${[a.rarity, a.boxType].filter((x): x is string => x !== null).map(titleCase).join(' ')} Box` : ''}</p>
      <ul>{a.rewards.map(r => <li key={r.itemId}>{r.quantity} × {r.name}</li>)}</ul>
    </article>)}
  </section>;
}
